import { Component, Input } from '@angular/core';
import { DictationActivityEvent } from '../../models';

@Component({
  selector: 'app-activity-timeline',
  templateUrl: './activity-timeline.component.html',
  styleUrls: ['./activity-timeline.component.scss'],
})
export class ActivityTimelineComponent {
  @Input() events: DictationActivityEvent[] = [];
  @Input() loading = false;
  @Input() emptyMessage = 'No activity yet.';
  @Input() live = true;

  get visibleEvents(): DictationActivityEvent[] {
    return (this.events || []).filter(
      (evt) => !(evt.category === 'action_item' && (evt.step === 'approved' || evt.step === 'rejected'))
    );
  }
}
